import ReactGA from 'react-ga4';
import config from './config';

const isEnabled = Boolean(config.gaMeasurementId);

export function initAnalytics() {
  if (!isEnabled) {
    return;
  }
  ReactGA.initialize(config.gaMeasurementId);
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
}

export function trackContactSent() {
  if (!isEnabled) {
    return;
  }
  ReactGA.event("generate_lead", { method: "contact_form" });
}



// WEBPACK FOOTER //
// ./src/analytics.js